module.exports = __webpack_public_path__ + "img/montserrat-v15-latin-700.95be07da.svg";